import React from 'react';
import {FaFileAlt,FaSearch} from 'react-icons/fa';
import './HealthcareCase.css';
export default function HealthcareCaseIcon(){return <span className="healthcare-case-icon" aria-hidden="true"><FaFileAlt/><FaSearch/></span>;}
